import React from 'react';
import { scroller } from 'react-scroll';
import { useSelector } from 'react-redux';

import { ListingInfo as ListingInfoShared } from 'ha/components/Redesign/Listing';

import { useDisplayedPrice } from '../hooks/useDisplayedPrice';
import { getStreet } from '../selectors';

interface Props {
  onMapBtnClick?: () => void;
}

export const ListingInfo: React.FC<Props> = ({ onMapBtnClick }) => {
  const onBillsClick = React.useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();

      scroller.scrollTo('rental-conditions', {
        smooth: true,
        duration: 500,
        offset: -28,
      });
    },
    [],
  );
  const street = useSelector(getStreet);
  const priceInfo = useDisplayedPrice();

  return (
    <ListingInfoShared
      onMapBtnClick={onMapBtnClick}
      priceInfo={priceInfo}
      onBillsClick={onBillsClick}
      street={street}
    />
  );
};
